import { render, staticRenderFns } from "./VendorStatsReport.vue?vue&type=template&id=1cab5f62&scoped=true"
import script from "./VendorStatsReport.vue?vue&type=script&lang=js"
export * from "./VendorStatsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cab5f62",
  null
  
)

export default component.exports